import { IFile } from '@sdk/contracts';
import { Button, Image } from 'antd';
import { FC } from 'react';

import { Wrapper } from './ImagePreview.styles';

import { Icon } from '@/components/Icon';

const ANSWER_IMG_PREVIEW_WIDTH = 200;

type Props = {
  value?: IFile;
  onChange?: (v: undefined) => void;
};

export const ImagePreview: FC<Props> = ({ value, onChange }) => {
  if (!value) return null;

  return (
    <Wrapper width={ANSWER_IMG_PREVIEW_WIDTH}>
      <Image width={ANSWER_IMG_PREVIEW_WIDTH} src={value.url} />
      <Button
        size="small"
        type="primary"
        icon={<Icon i="TrashCan" />}
        onClick={() => onChange?.(undefined)}
      />
    </Wrapper>
  );
};
